import { InjectionToken } from '@angular/core';

import { TranslationScope } from './translation-scope.type';

export const TRANSLATION_SCOPES = new InjectionToken<TranslationScope[]>('Translation Scopes');
